import React, { Component } from "react";
import Helmet from "react-helmet";
import config from "../../data/SiteConfig";
import "./styles/blog.css";
import SEO from "../components/SEO/SEO";
import Jumbotron from "../components/Jumbotron/Jumbotron";
import BlogResults from "../components/BlogResults/BlogResults";

class BlogPage extends Component {
  render() {
    const postEdges = this.props.data.allMarkdownRemark.edges;
    return (
      <div className="BlogPage">
        <Helmet title={`Blog | ${config.siteTitle}`} />
        <SEO postEdges={postEdges} />
        <Jumbotron message="Blog" />
        <div className="BlogPage__content Container">
          <BlogResults postEdges={postEdges} title="Latest Posts" />
        </div>
      </div>
    );
  }
}

export default BlogPage;

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query BlogQuery {
    allMarkdownRemark(
      limit: 100
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          fields {
            slug
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            cover
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/blog.jsx